import React from "react";
import PolicyLayout from "./PolicyLayout";
import { formatMoney, SITE_CONFIG } from "../config/siteConfig";

function PaymentPolicy() {
  return (
    <PolicyLayout
      title="Payment, pricing and fraud policy"
      intro={`Catalogue prices and checkout totals are presented in ${SITE_CONFIG.currency}; each order adds ${formatMoney(SITE_CONFIG.shippingFee)} shipping.`}
    >
      <section>
        <h2>Displayed total</h2>
        <p>The payable amount is the sum of the selected product prices and the fixed shipping charge shown before Pay Now. Quantity changes update the merchandise subtotal. For international destinations, customs duties, import taxes and clearance assessments are not part of this displayed total.</p>
      </section>

      <section>
        <h2>Hosted card payment</h2>
        <p>The React checkout collects delivery fields but does not contain card-number, expiry or security-code inputs. Pay Now sends encoded order data to the same-origin payment endpoint and redirects the customer to Stripe's hosted checkout. The methods and authentication steps displayed there are the methods available for that payment session.</p>
      </section>

      <section>
        <h2>Verification and return pages</h2>
        <p>Each attempt uses a randomly generated order number. A success, cancellation or failure page describes the browser's return state only. Fulfilment, cancellation and refunds depend on the corresponding provider record, not on editing or revisiting a result-page URL.</p>
      </section>

      <section>
        <h2>Pricing errors and duplicate attempts</h2>
        <p>If the hosted amount does not match the checkout total, leave the payment page and report the order number rather than trying to alter the URL. A clear pricing or calculation error may be corrected before acceptance. Where a duplicate payment is verified for the same intended order, the duplicate amount is returned through its original payment route.</p>
      </section>

      <section>
        <h2>Fraud and payment safety</h2>
        <p>We may pause or decline an order when the payment record, email, amount, destination, age declaration or ordering pattern provides objective evidence of fraud, unauthorised use or endpoint manipulation. Review is limited to information relevant to the transaction. Never email full card details or a one-time security code; report an unauthorised charge promptly to the card issuer and to support with the order reference.</p>
      </section>

      <section>
        <h2>Refund destination and mandatory rights</h2>
        <p>Approved refunds are submitted to the original payment route to reduce diversion and fraud risk. Payment review does not remove a consumer's non-excludable remedy for non-supply, unsafe goods, false description or another protected failure.</p>
      </section>
    </PolicyLayout>
  );
}

export default PaymentPolicy;
